<template>
  <div class="tw-bg-gray-50">
    <WdsSegmentedControl
      :default-active-key="timesheetFormStore.selectedWeekNumber?.toString()"
      data-test="timesheet-week-control"
      @click="timesheetFormStore.jumpToWeekNumber"
    >
      <WdsSegmentedControlButton
        v-for="(weekData, key) in timesheetFormStore.weekRange"
        :key="key"
        :option-key="key.toString()"
      >
        <div class="tw-text-right tw-px-4">
          <WdsText small>
            {{ `${$t(weekData.dates[0].format('MMM'))} ${weekData.dates[0].format('DD')}` }} -
            {{ `${$t(weekData.dates[6].format('MMM'))} ${weekData.dates[6].format('DD, YYYY')}` }}
          </WdsText>
          <WdsText>
            <strong
              :class="{
                'tw-text-indigo-500': timesheetFormStore.weeklyReportedTime[key] !== 0,
              }"
            >
              {{ formatFixedDecimal(timesheetFormStore.weeklyReportedTime[key]) }}
              {{
                timesheetFormStore.useDayInputs
                  ? $t('d (day abbreviation)')
                  : $t('h (hour abbreviation)')
              }}
            </strong>
          </WdsText>
        </div>
      </WdsSegmentedControlButton>
    </WdsSegmentedControl>
  </div>
</template>

<script setup lang="ts">
import { WdsSegmentedControl, WdsSegmentedControlButton, WdsText } from '@worksome/wds-components'
import { useTranslation } from '@/composables/translation'
import { useTimesheetFormStore } from '@/components/Timesheet/store/useTimesheetFormStore'
import formatFixedDecimal from '@/components/Timesheet/utilities/formatFixedDecimal'

const { $t } = useTranslation()
const timesheetFormStore = useTimesheetFormStore()
</script>

<style scoped>

:deep(.wds-segmented-control) {
  @apply tw-max-w-full;
  @apply tw-overflow-auto;
}
:deep(.wds-segmented-control-button) {
  @apply tw-whitespace-nowrap;
}
</style>
